// eslint-disable-next-line import/prefer-default-export
export { default as SSGizmo } from './ss-gizmo.css';
